<!-- 模板的弹出框 -->
<template>
  <div class="PopupBox">
    <div
      :class="[
        'createBooking',
        {
          createBookingRight: !FrameProperty.aleft,
          createBookingBottom: !FrameProperty.upward,
          createBookingRightBottom:
            !FrameProperty.aleft && !FrameProperty.upward,
        },
      ]"
      :style="{
        top: FrameProperty.top + 'px',
        left: FrameProperty.left + 'px',
      }">
      <!-- 头部标题 -->
      <div class="EventWrapTitle">
        <div
          v-if="this.EventMotionSelect == 0"
          class="EventTopTitle">
          <p
            class="event_color"
            :style="{ background: eventDetail.color }"></p>
          <p class="Event_title">{{ eventDetail.title }}</p>
        </div>
        <ul
          class="CompileTitle"
          v-else>
          <li
            @click="CompileType = 'note'"
            :class="{ active: CompileType === 'note' }">
            {{ $t('lang.note') }}
          </li>
          <li class="separator">|</li>
          <li
            @click="CompileType = 'events'"
            :class="{ active: CompileType === 'events' }">
            Events
          </li>
          <li class="separator">|</li>
          <li
            @click="CompileType = 'device'"
            :class="{ active: CompileType === 'device' }">
            {{ $t('lang.device') }}
          </li>
        </ul>
        <div
          class="iconfont closeCreateBox"
          @click="closeCreateBox">
          &#xe603;
        </div>
      </div>
      <!-- 视频的详情 -->
      <div
        class="EventDetail"
        v-if="EventMotionSelect == 0">
        <div class="detail_item">
          <p class="detailLeft">{{ $t('lang.time') }}</p>
          <p class="detailRight">
            {{ displayTime(eventDetail.startTime, eventDetail.endTime) }}
          </p>
        </div>
        <div class="detail_item">
          <p class="detailLeft">{{ $t('lang.reporter') }}</p>
          <p class="detailRight">{{ eventDetail.reporter }}</p>
        </div>
        <div class="detail_item storySlug">
          <p class="detailLeft">{{ $t('lang.storySlug') }}</p>
          <p class="detailRight">{{ eventDetail.description }}</p>
        </div>
        <div class="detail_item">
          <p class="detailLeft">{{ $t('lang.source') }}</p>
          <p class="detailRight">{{ eventDetail.tname }}</p>
        </div>
        <div class="detail_item">
          <p class="detailLeft">{{ $t('lang.bookingChannel') }}</p>
          <p class="detailRight">{{ eventDetail.rname }}</p>
        </div>
        <div class="detail_item">
          <p class="detailLeft">Secondary Record</p>
          <p class="detailRight">
            {{ eventDetail.record == 1 ? 'Enable' : 'Disable' }}
          </p>
        </div>
        <div
          class="eventsDetail"
          v-if="subeventSwitch">
          <div
            class="detail_item"
            :class="{ detailbottom: subeventSwitch == 2 }">
            <p class="detailLeft">Events</p>
            <p
              class="detailRight"
              @click="
                subeventSwitch == 1
                  ? (subeventSwitch = 2)
                  : (subeventSwitch = 1)
              ">
              <i
                class="el-icon-arrow-down"
                v-if="subeventSwitch == 1"></i>
              <i
                class="el-icon-arrow-up"
                v-else></i>
            </p>
          </div>
          <div
            class="eventsListWrap"
            v-if="subeventSwitch == 2">
            <div
              class="eventsBox"
              v-for="item in subeventList"
              :key="item.id">
              <div class="title">{{ SetSubeventName(item) }}</div>
              <div class="time">
                {{ displayTime(item.timingIn, item.timingOut, 1) }}
              </div>
              <div class="duration">
                {{ calculateInterval(item.accumulatedProgramTiming) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 创建与修改事件 -->
      <div
        class="EventUpdateandCreate"
        :id="`${(eventDetail.liveStatus == 2 || eventDetail.liveStatus == 4) ? 'EventUpdateandCreate' : ''}`"
        v-else>
        <!-- note部分 -->
        <div
          class="note"
          v-if="CompileType === 'note'">
          <div class="c_item">
            <input
              type="text"
              v-model="eventDetail.title"
              :placeholder="$t('lang.createTitle')" />
            <div
              class="color_box"
              @click="mostSwitch.ColorShow = !mostSwitch.ColorShow">
              <div :class="['color', ColorTransition(eventDetail.color)]"></div>
              <i :class="['el-icon-caret-bottom', { top: mostSwitch.ColorShow }]"></i>
              <div
                class="color_opt"
                v-if="mostSwitch.ColorShow">
                <span>{{ $t('lang.color') }}</span>
                <ul>
                  <li
                    v-for="(item, index) in colorArr"
                    :key="index"
                    :class="[item.name]"
                    @click.stop="chooseColor(item)"></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="DuplicateHint" v-if="IsCopyEvent">
            Duplicate Event Start Time
          </div>
          <div class="c_item timeSelete">
            <div class="time_opt">
              <el-date-picker
                type="datetime"
                v-model="eventDetail.startTime"
                popper-class="pick_date_time"
                :picker-options="pickerDateStart"
                :placeholder="$t('lang.selectData')"
                value-format="timestamp"
                format="yyyy-MM-dd h:mm:ss A"
                @change="changeStartTime"
                :disabled="mostSwitch.IsProgress">
              </el-date-picker>
            </div>
            <div class="to">-</div>
            <div class="time_opt">
              <el-date-picker
                type="datetime"
                v-model="eventDetail.endTime"
                popper-class="pick_date_time"
                :picker-options="pickerDateEnd"
                :placeholder="$t('lang.selectData')"
                value-format="timestamp"
                format="yyyy-MM-dd h:mm:ss A"
                @change="changeEndTime">
              </el-date-picker>
            </div>
          </div>
          <div class="c_item">
            <input
              type="text"
              class="reporter"
              :placeholder="$t('lang.reporter')"
              v-model="eventDetail.reporter" />
          </div>
          <div class="c_item HouseID">
            <p class="HouseIDKey">House ID :</p>
            <p class="HouseIDVaule">
              <input
              type="text"
              v-model="eventDetail.houseId"
              placeholder="House ID" />
            </p>
          </div>
          <div class="c_item RecordSelete">
            <el-checkbox
              v-model="eventDetail.record"
              :disabled="mostSwitch.IsProgress">{{ $t('lang.SecondaryRecord') }}</el-checkbox>
          </div>
          <div class="c_item des">
            <textarea
              name=""
              id=""
              cols="30"
              rows="10"
              style="height:60px;resize:none"
              maxlength="255"
              :placeholder="$t('lang.des')"
              v-model="eventDetail.description"></textarea>
          </div>
        </div>
        <!-- events部分 -->
        <div
          class="EventsWrap"
          v-else-if="CompileType === 'events'">
          <div class="ReferenceMedia">
            <div class="MediaType">
              <el-select
                v-model="eventDetail.sourceType"
                @change="SourceTypeChange"
                placeholder="Source type">
                <el-option
                  v-for="(item, index) in ['Media', 'Live']"
                  :key="index"
                  :label="item"
                  :value="index">
                </el-option>
              </el-select>
            </div>
            <div class="MediaSelect">
              <public-file-select
                v-if="!eventDetail.sourceType"
                :SelectType="1"
                :SelectValue="{
                  fileId: eventDetail.fileId,
                  fileName: eventDetail.tname,
                }"
                :AppendBody="false"
                @fileSelectChange="
                  pitchOnFile => fileSeleteChange(pitchOnFile, 1)
                "></public-file-select>
              <el-select
                v-else
                v-model="eventDetail.tpeerid"
                :popper-append-to-body="false"
                v-scroll="SourcebindScroll"
                filterable
                :filter-method="getSourceList"
                @change="SelectSource">
                <el-option
                  v-for="item in SourceList"
                  :key="item.peerId"
                  :label="item.name"
                  :value="item.peerId">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="EventsTitle">
            <div class="MediaIndex"></div>
            <div class="Title-item"></div>
            <div class="Title-item">{{ $t('lang.Event') }}</div>
            <div class="Title-item">{{ $t('lang.File') }}</div>
            <div class="Title-item">{{ $t('lang.TimingIn') }}</div>
            <div class="Title-item">{{ $t('lang.TimingOut') }}</div>
            <div class="Title-item Duration">{{ $t('lang.duration') }}</div>
          </div>
          <div class="EventsListWrap">
            <div
              class="EventsList"
              v-for="(subevent, index) in subeventList"
              :key="index">
              <div class="MediaIndex">
                <span v-if="subevent.segmentId == 1">{{ subevent.SerialNumber }}</span>
              </div>
              <!-- Segments -->
              <div class="Title-item">
                <div class="GxtScte">
                  <el-select
                    v-model="subevent.segmentId"
                    :popper-append-to-body="false"
                    @change="SegmentsChang(subevent)">
                    <el-option
                      v-for="item in SegmentsType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!-- Event -->
              <div class="Title-item">
                <div
                  class="GxtScte"
                  v-if="subevent.segmentId == 2 || subevent.segmentId == 3">
                  <!-- scte -->
                  <el-select
                    v-if="subevent.segmentId == 2"
                    v-model="subevent.eventOperationType"
                    :popper-append-to-body="false">
                    <el-option
                      v-for="item in ScteSpliceType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <!-- GFX -->
                  <el-select
                    v-if="subevent.segmentId == 3"
                    v-model="subevent.eventOperationType"
                    :popper-append-to-body="false">
                    <el-option
                      v-for="item in logoConfig"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div
                  class="noSelete"
                  v-else>
                  {{ subevent.eventOperationType }}
                </div>
              </div>
              <!-- File -->
              <div class="Title-item">
                <div
                  class="GxtScte fileSelete"
                  v-if="
                    (subevent.segmentId == 2 &&
                      subevent.eventOperationType == 'Underplay clip') ||
                      subevent.segmentId == 4 ||
                      subevent.segmentId == 5 ||
                      subevent.segmentId == 10
                  ">
                  <public-file-select
                    :SelectType="1"
                    :SelectValue="{
                      fileId: subevent.fileId,
                      fileName: subevent.fileName,
                    }"
                    :AppendBody="false"
                    @fileSelectChange="
                      pitchOnFile => fileSeleteChange(pitchOnFile, subevent)
                    "></public-file-select>
                </div>
                <div
                  class="noSelete"
                  v-else></div>
              </div>
              <!-- Timing-In -->
              <div class="Title-item timePicker">
                <el-time-picker
                  v-model="subevent.ShowTimingIn"
                  :picker-options="{
                    selectableRange: subeventDateLimit,
                  }"
                  :default-value="new Date(eventDetail.startTime)"
                  value-format="HH:mm:ss"
                  format="h:mm:ss A"
                  @blur="DateChange(subevent, index)">
                </el-time-picker>
              </div>
              <!-- Timing-Out -->
              <div class="Title-item timePicker">
                <el-time-picker
                  v-model="subevent.ShowTimingOut"
                  :picker-options="{
                    selectableRange: subeventDateLimit,
                  }"
                  :default-value="new Date(eventDetail.startTime)"
                  value-format="HH:mm:ss"
                  format="h:mm:ss A"
                  @blur="DateChange(subevent, index)">
                </el-time-picker>
              </div>
              <!-- Duration -->
              <div class="Title-item Duration-item">
                <div class="Duration">
                  {{ calculateInterval(subevent.accumulatedProgramTiming) }}
                </div>
              </div>
              <!-- 删除操作 -->
              <div class="delete-item">
                <div
                  class="delete"
                  @click="deleteSubevent(subevent, index)">
                  <i class="iconfont icon-icon14"></i>
                </div>
              </div>
            </div>
            <div class="addSubevent">
              <i
                class="iconfont icon-add"
                @click="addSubevent()"></i>
            </div>
          </div>
        </div>
        <!-- device部分 -->
        <div
          class="device"
          v-else>
          <div class="d_item source">
            <span>{{ $t('lang.bookingChannel') }}</span>
            <span class="val">{{ eventDetail.rname }}</span>
          </div>
          <!-- <div class="d_item pr">
            <span>{{ $t("lang.deviceSourceScte") }}</span>
            <span
              :class="[
                'val',
                'ValSelet',
                {
                  up: mostSwitch.BoxSourceList,
                },
              ]"
              @click="mostSwitch.BoxSourceList = !mostSwitch.BoxSourceList"
            >
              <span>{{ eventDetail.tname }}</span>
              <div
                class="createbox_r_list"
                :class="{ show_height: mostSwitch.showHeight }"
                v-if="mostSwitch.BoxSourceList"
              >
                <ul
                  class="infinite-list"
                  v-infinite-scroll="getSourceList"
                  style="overflow: auto"
                >
                  <li
                    v-for="(item, index) in SourceList"
                    :key="index"
                    class="infinite-list-item"
                    @click="SelectSource(item)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </span>
          </div> -->
          <div class="d_item">
            <span>{{ $t('lang.delay') }}{{ Rversions ? '(0.3-50s)' : '(0.5-50s)' }}</span>
            <input
              type="text"
              :class="['input', { delay: mostSwitch.editDelay }]"
              v-model="eventDetail.delay"
              @focus="mostSwitch.editDelay = true"
              @blur="DelayBitChange('editDelay')"
              oninput="value=value.replace(/[^\d.]/g,'')" />
          </div>
          <div class="d_item">
            <span>{{ $t('lang.bit') }}(100-10240Kbps)</span>
            <input
              type="text"
              :class="['input', { bitrate: mostSwitch.editBit }]"
              v-model="eventDetail.bitrate"
              @focus="mostSwitch.editBit = true"
              @blur="DelayBitChange('editBit')"
              oninput="value=value.replace(/[^\d.]/g,'')" />
          </div>
        </div>
      </div>

      <!-- 底下的操作 -->
      <div class="create_footer">
        <div
          class="DetailButton"
          v-show="EventMotionSelect == 1">
          <button
            class="delete"
            v-if="!(eventDetail.liveStatus == 2 || eventDetail.liveStatus == 4)"
            @click="DeleteEvent">
            {{ $t('lang.delete') }}
          </button>
          <button
            class="copy"
            :style="{'margin-right':(eventDetail.liveStatus == 2 || eventDetail.liveStatus == 4) ? '50px': ''}"
            @click="copyEvent">
            {{ $t('lang.copy') }}
          </button>
          <!-- <button class="edit" @click="EventMotionSelect = 1">
            {{ $t("lang.edit") }}
          </button> -->
        </div>
        <div
          class="ComplieButton"
          v-show="EventMotionSelect != 0">
          <button
            class="cancel"
            @click="closeCreateBox">
            {{ $t('lang.cancel') }}
          </button>
          <button
            class="save f_right"
            v-show="EventMotionSelect == 1 && !(eventDetail.liveStatus == 2 || eventDetail.liveStatus == 4)"
            @click="SaveEvent">
            {{ $t('lang.save') }}
          </button>
          <button
            class="save"
            v-show="EventMotionSelect == 2"
            @click="CreateEvent">
            {{ $t('lang.create') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import { creatAccount } from '@/assets/js/common/creatAccount.js'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'
import PublicFileSelect from '@/components/common/PublicFileSelect.vue'
import {
  Segments,
  LogoConfig,
  ScteType,
  UnderplayType
} from '@/assets/js/temConfig.js'

const googleKey = 'playout'
export default {
  props: {
    // 选中的事件
    picthOnEvent: {
      type: Object,
      default: () => ({
        //   新加子事件scte属性
        eventSegments: []
      })
    },
    // 对事件的几种操作
    EventMotion: {
      type: [String, Number],
      default: 1
    }, // 0 展示 1编辑 2创建
    // R的信息
    fixedDevice: Object,
    // 鼠标所点位置
    BoxPosition: {
      type: Object,
      default: () => ({
        top: 500,
        left: 500
      })
    }
  },
  data () {
    return {
      // R的版本大于7.6
      Rversions: false,
      // 对事件的几种操作
      EventMotionSelect: 0,
      // 是否copy
      IsCopyEvent: false,
      // 弹出框的一些属性
      FrameProperty: {
        left: 100,
        top: 200
      },
      // 所有事件时间
      AllEventTime: {
        EventStarttime: 0, // 上一次主事件开始时间
        EventTime: 0, // 主事件时间
        VideoTime: 0, // 主视频时间
        SubeventTime: 0 // 子事件时间
      },
      // 事件的详细信息
      eventDetail: {
        record: false
      },
      //  是note还是device
      CompileType: 'note',
      // 一系列开关
      mostSwitch: {
        // 颜色开关
        ColorShow: false,
        // 选择Source
        BoxSourceList: false,
        // 编辑Delay 延时时间
        editDelay: false,
        // 编辑bit率
        editBit: false,
        // 是否正在执行
        IsProgress: false
      },
      //   颜色选项
      colorArr: [
        {
          name: 'green',
          value: 'rgb(15, 190, 113)'
        },
        {
          name: 'skyblue',
          value: 'rgb(70, 201, 225)'
        },
        {
          name: 'blue',
          value: 'rgb(14,107,209)'
        },
        {
          name: 'orange',
          value: 'rgb(255, 197, 115)'
        },
        {
          name: 'pink',
          value: 'rgb(255, 106, 146)'
        },
        {
          name: 'yellow',
          value: 'rgb(255, 192, 0)'
        },
        {
          name: 'purple',
          value: 'rgb(146, 72, 199)'
        }
      ],
      // Source查询列表
      SourceList: [],
      // Source查询分页
      SourcePaging: {
        SourcepageNum: 0,
        loadEnd: false
      },
      // source滚动加载
      SourcebindScroll: {
        onScroll: this.getSourceList,
        directive: '.el-scrollbar__wrap',
        distance: 50
      },
      //   子事件是否显示
      subeventSwitch: 1, // 0不显示  1显示但不显示列表 2显示列表
      SubeventTypeSelete: {
        // 初始配置文件，TODO:改为从initConfig中获取
        segments: Segments,
        scteType: ScteType,
        logoConfig: LogoConfig,
        underplayType: UnderplayType
      },
      // segments类型
      SegmentsType: [
        {
          value: 6,
          label: 'SCTE Program Start'
        },
        {
          value: 1,
          label: 'Reference Media'
        },
        {
          value: 2,
          label: 'SCTE(Splice time)'
        },
        // {
        //     value: 3,
        //     label: 'GFX'
        // },
        {
          value: 4,
          label: 'Underplay'
        },
        {
          value: 5,
          label: 'Promo'
        },
        {
          value: 10,
          label: 'Media'
        },
        // {
        //     value: 8,
        //     label: 'Slate'
        // },
        {
          value: 9,
          label: 'Black'
        },
        {
          value: 7,
          label: 'SCTE Program End'
        }
      ],
      // ScteSplice类型
      ScteSpliceType: [
        {
          value: 'SCTE only',
          label: 'SCTE only'
        },
        {
          value: 'Underplay clip',
          label: 'Underplay clip'
        }
      ],
      // logo类型
      logoConfig: [],
      // subevent列表
      subeventList: [],
      // 编辑时删除的子事件
      DeleteSubeventList: [],
      //   时间选择限制
      pickerDateStart: {
        disabledDate (time) {
          var date = Outil.getDateTime()
          return (
            time.getTime() <
            new Date(
              `${date.year}-${date.month}-${date.day} 00:00:00`
            ).getTime()
          )
        }
      },
      pickerDateEnd: {
        disabledDate (time) {
          var date = Outil.getDateTime()
          return (
            time.getTime() <
            new Date(
              `${date.year}-${date.month}-${date.day} 00:00:00`
            ).getTime()
          )
        }
      },
      //   子事件选择限制
      subeventDateLimit: '00:00:00 - 23:01:00'
    }
  },
  components: {
    PublicFileSelect
  },
  watch: {
    // 监听子事件变化
    subeventList () {
      // 通过子事件变化改变主事件时间
      this.ChangeTotalEvent()
    },
    // 监听r变化
    fixedDevice () {
      this.closeCreateBox()
    }
  },
  created () {
    this.EventMotionSelect = this.EventMotion == 0 || this.EventMotion == 1 ? 1 : this.EventMotion
    // 设置弹出框位置
    this.FrameProperty = JSON.parse(JSON.stringify(this.BoxPosition))
    // 判断是查看还是编辑
    this.estimateOperate()
    // 获取source列表
    // this.getSourceList()
  },
  mounted () {
    if (this.fixedDevice.version) {
      let { version } = this.fixedDevice
      if (this.fixedDevice.version.length > 3) version = this.fixedDevice.version.substr(0, 3)
      if (version >= '7.6') this.Rversions = true
    }
  },
  methods: {
    // 处理子事件没有name问题
    SetSubeventName (item) {
      let Name = item.eventOperationType
      if (!Name) {
        const SegmentsItem = this.SegmentsType.filter(
          (m) => m.value == item.segmentId
        )
        Name = SegmentsItem[0].label
      }
      return Name
    },
    // 更改创建开始时间
    changeStartTime (val) {
      // 如果开始时间小于当前时间  一般不会有这种情况
      if (val <= new Date().getTime()) {
        this.eventDetail.startTime = null
        this.$message.error(this.$t('lang.startTimeMoreCurTime'))
        return
      }
      // 禁止跨天
      // if (this.eventDetail.startTime && this.eventDetail.endTime) {
      //   if (
      //     Outil.changeNewDate(this.eventDetail.startTime) !=
      //     Outil.changeNewDate(this.eventDetail.endTime)
      //   ) {
      //     this.eventDetail.endTime = null
      //     this.$message.error('Does not support cross-day creation of events')
      //   }
      // }
      //   编辑的时候
      if (this.EventMotionSelect == 1 || (this.EventMotionSelect == 2 && this.IsCopyEvent)) {
        const durTime = this.AllEventTime.EventTime
        if (this.eventDetail.endTime - val != durTime) {
          this.eventDetail.endTime = this.eventDetail.startTime + durTime
        }
        // 创建或者复制的时候
      } else if (this.eventDetail.endTime && this.eventDetail.endTime - val < 0) {
        this.eventDetail.endTime = null
        this.$message.error(this.$t('lang.endTimeMoreStartTime'))
      }
      this.setSubeventDateLimit()
    },
    // 更改创建结束时间
    changeEndTime (val) {
      // 如果结束时间小于当前时间  一般不会有这种情况
      if (val < new Date().getTime()) {
        this.eventDetail.endTime = null
        this.$message.error(this.$t('lang.endTimeMoreCurTime'))
        return
      }
      // 禁止跨天
      // if (this.eventDetail.startTime && this.eventDetail.endTime) {
      //   if (
      //     Outil.changeNewDate(this.eventDetail.startTime) !=
      //     Outil.changeNewDate(this.eventDetail.endTime)
      //   ) {
      //     this.eventDetail.endTime = null;
      //     this.$message.error('Does not support cross-day creation of events');
      //   }
      // }
      //   编辑时禁止改结束时间,所以不做判断
      // 创建或者复制的时候
      if (
        this.eventDetail.endTime &&
        this.eventDetail.endTime - this.eventDetail.startTime < 0
      ) {
        this.eventDetail.endTime = null
        this.$message.error(this.$t('lang.endTimeMoreStartTime'))
      }
    },
    // 文件选择变化
    fileSeleteChange (pitchOnFile, item) {
      // 主文件选择
      if (item === 1) {
        this.eventDetail.tname = pitchOnFile.name
        this.eventDetail.tpeerid = pitchOnFile.sourceId
        this.eventDetail.ttype = pitchOnFile.type
        this.eventDetail.fileId = pitchOnFile.id
        // this.$set(this.eventDetail, 'tpeerid', pitchOnFile.sourceId);
      } else {
        let videoTimes = pitchOnFile.videoTimes ? Number(pitchOnFile.videoTimes) : pitchOnFile.videoTimes
        videoTimes = videoTimes * 1000
        item.timingOut = item.timingIn + videoTimes
        if (item.timingOut > this.eventDetail.endTime) item.timingOut = this.eventDetail.endTime
        item.accumulatedProgramTiming = item.timingOut - item.timingIn
        item.ShowTimingOut = item.timingOut ? Outil.changeNewTime(item.timingOut) : item.timingOut
        this.$set(item, 'fileId', pitchOnFile.id)
      }
    },
    // 子事件Segments变化
    SegmentsChang (item) {
      // 清空事件选择以及文件选择
      this.$set(item, 'eventOperationType', null)
      this.$set(item, 'fileId', null)
    },
    // 删除子事件
    deleteSubevent (subevent, index) {
      // 编辑时删除的已经存在的子事件
      if (subevent.id) {
        this.DeleteSubeventList.push(subevent)
      }
      this.subeventList.splice(index, 1)
    },
    // 添加子事件
    addSubevent () {
      creatAccount()
      // this.subeventList.push({})
    },
    // 子事件的时间校验以及计算时间间隔
    DateChange (subevent, index) {
      // 赋予时间
      if (subevent.ShowTimingIn) {
        subevent.timingIn = new Date(
          `${this.eventDetail.newdate} ${subevent.ShowTimingIn}`
        ).getTime()
      }
      if (subevent.ShowTimingOut) {
        subevent.timingOut = new Date(
          `${this.eventDetail.newdate} ${subevent.ShowTimingOut}`
        ).getTime()
      }
      // 结束时间应大于开始时间
      if (
        subevent.timingIn &&
        subevent.timingOut &&
        subevent.timingOut - subevent.timingIn < 0
      ) {
        subevent.timingOut = subevent.timingIn
        subevent.ShowTimingOut = null
        return
      }
      // 计算时间间隔
      if (subevent.timingIn && subevent.timingOut) {
        this.$set(
          subevent,
          'accumulatedProgramTiming',
          subevent.timingOut - subevent.timingIn
        )
      }
      // 通过子事件变化改变主事件时间
      // this.ChangeTotalEvent()
    },
    // 获取source列表
    getSourceList (value) {
      this.SourcePaging.SourcepageNum++
      const param = {
        bookmardIds: 'all',
        unClassified: true,
        pack: true,
        anywhere: true,
        gridPack: true,
        gridSdi: true,
        ext: true,
        token: true,
        scte: true,
        pageNum: this.SourcePaging.SourcepageNum,
        pageSize: 35,
        condition: ''
      }
      if (value) {
        this.SourcePaging.SourcepageNum = 1
        param.condition = value
        param.pageNum = this.SourcePaging.SourcepageNum
        this.SourcePaging.loadEnd = false
      }
      this.SourceList = []
      this.SourcePaging.loadEnd = true
    },
    // 选择source
    SelectSource (peerId) {
      const FileMessage = this.SourceList.filter((item) => item.peerId === peerId)
      this.eventDetail.tname = FileMessage[0].name
      // this.eventDetail.tpeerid = FileMessage[0].peerId;
      this.$set(this.eventDetail, 'tpeerid', FileMessage[0].peerId)
      this.eventDetail.ttype = FileMessage[0].type
    },
    // 空白占位符选择文件后编辑颜色
    BlankEditColor () {
      if (this.eventDetail.color == 'rgb(255, 255, 255)' && this.eventDetail.tpeerid) {
        this.eventDetail.color = 'rgb(255, 192, 0)'
      }
    },
    // 选择颜色
    chooseColor (item) {
      this.eventDetail.color = item.value
      this.mostSwitch.ColorShow = false
    },
    // 复制事件
    copyEvent () {
      this.EventMotionSelect = 2
      this.eventDetail.liveStatus = 0
      this.IsCopyEvent = true
      this.subeventList.forEach((item) => {
        delete item.id
      })
    },
    // 请求前参数处理
    RequestBeforeData (type) {
      this.eventDetail.eventSegments = []
      this.eventDetail.addEventSegments = []
      this.eventDetail.deleteEventSegments = []
      // type 1 编辑 0创建
      if (type) {
        this.subeventList.forEach((item) => {
          if (item.id) {
            this.eventDetail.eventSegments.push(item)
          } else {
            this.eventDetail.addEventSegments.push(item)
          }
        })
        this.eventDetail.deleteEventSegments = this.DeleteSubeventList
      } else {
        this.eventDetail.eventSegments = this.subeventList
      }

      const param = JSON.parse(JSON.stringify(this.eventDetail))
      param.record = param.record ? 1 : 0
      return param
    },
    // 保存事件
    SaveEvent () {
      const googleAnalyzeEvent = `${googleKey}CalendarEventEditSave`
      playoutAnalyze(googleAnalyzeEvent, '/po')
      this.BlankEditColor()
      const param = this.RequestBeforeData(1)

      if (!param.title && param.title !== 0) {
        this.$message.error(this.$t('lang.titleEmpty'))
        return
      }
      if (!param.rpeerid) {
        this.$message.error(this.$t('lang.rEmpty'))
        return
      }
      if (param.title.indexOf('/') >= 0) {
        this.$message.error(`"/" ${this.$t('lang.notAllowedName')}`)
        return
      }
      this.OperationSuccess({
        type: 'save',
        eventDetail: param
      })
    },
    // 创建事件
    CreateEvent () {
      const param = this.RequestBeforeData(0)
      if (!param.title && param.title !== 0) {
        this.$message.error(this.$t('lang.titleEmpty'))
        return
      }
      if (!param.rpeerid) {
        this.$message.error(this.$t('lang.rEmpty'))
        return
      }
      if (param.title.indexOf('/') >= 0) {
        this.$message.error(`"/" ${this.$t('lang.notAllowedName')}`)
        return
      }
      this.OperationSuccess({
        type: 'create',
        eventDetail: this.eventDetail
      })
    },
    // 删除事件
    DeleteEvent () {
      const Time = new Date().getTime()
      if (Time > this.eventDetail.startTime) {
        this.$message(this.$t('lang.executedCanntDeleted'))
        return
      }
      playoutAnalyze(`${googleKey}CalendarEventDelete`, '/po')
      this.$confirm(this.$t('lang.prompEnsureDel'), '', {
        confirmButtonText: this.$t('lang.btn'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        this.OperationSuccess({
          type: 'delete',
          eventDetail: this.eventDetail
        })
      })
        .catch(() => {
        // 取消操作
        })
    },
    // 保存 删除 创建 操作成功
    OperationSuccess (data) {
      this.$emit('OperationSuccess', data)
    },
    // 关闭弹出框
    closeCreateBox () {
      this.$emit('closeCreateBox')
    },
    // DelayBit变化
    DelayBitChange (key) {
      this.mostSwitch[key] = false
      if (key == 'editDelay') {
        let delay
        if (this.eventDetail.delay) {
          delay = Number(this.eventDetail.delay.replace(/[^\d.]/g, ''))
        }
        if (this.Rversions) {
          this.eventDetail.delay = delay < 0.3 ? '0.3' : this.eventDetail.delay
        } else {
          this.eventDetail.delay = delay < 0.5 ? '0.5' : this.eventDetail.delay
        }
        this.eventDetail.delay = delay > 50 ? '50' : this.eventDetail.delay
      } else if (key == 'editBit') {
        let bitrate
        if (this.eventDetail.bitrate) {
          bitrate = Number(this.eventDetail.bitrate.replace(/[^\d.]/g, ''))
        }
        this.eventDetail.bitrate =
          bitrate < 100 ? '100' : this.eventDetail.bitrate
        this.eventDetail.bitrate =
          bitrate > 10240 ? '10240' : this.eventDetail.bitrate
      }
    },
    // 转换颜色
    ColorTransition (color) {
      const colorName = this.colorArr.filter((item) => item.value == color)
      return colorName[0] ? colorName[0].name : 'purple'
    },
    // 判断是查看还是创建，赋予数据
    estimateOperate () {
      this.eventDetail = JSON.parse(JSON.stringify(this.picthOnEvent))
      this.eventDetail.record = !!this.eventDetail.record
      this.eventDetail.color = this.eventDetail.color
        ? this.eventDetail.color
        : 'rgb(255, 192, 0)'
      //   计算事件的时长，时间间隔
      this.eventDetail.duration = this.eventDetail.duration
        ? this.eventDetail.duration
        : this.eventDetail.endTime - this.eventDetail.startTime
      //   查看和编辑
      if (this.EventMotionSelect == 0 || this.EventMotionSelect == 1) {
        // 判断源是视频还是t
        if (this.eventDetail.ttype) {
          if (
            ['video', 'file'].includes(
              this.eventDetail.ttype && this.eventDetail.ttype.toLowerCase()
            )
          ) {
            this.eventDetail.sourceType = 0
            this.eventDetail.fileId = this.eventDetail.tname
          } else {
            this.eventDetail.sourceType = 1
          }
        }
        // 取delay,bitrate
        if (this.eventDetail.parameters) {
          const parameters =
            typeof this.eventDetail.parameters == 'object'
              ? this.eventDetail.parameters
              : JSON.parse(this.eventDetail.parameters)
          this.eventDetail.reporter = parameters.reporter
          this.eventDetail.delay = parameters.delay
          this.eventDetail.bitrate = parameters.bitrate
        }
        // 判断开始时间是否小于现在，小于则正在执行
        if (this.eventDetail.startTime <= new Date().getTime() && this.eventDetail.startTime > new Date().getTime()) {
          this.mostSwitch.IsProgress = true
        }
      } else if (this.EventMotionSelect == 2) {
        this.eventDetail.rname = this.fixedDevice.name
        this.eventDetail.rpeerid = this.fixedDevice.peerId
      }
      //   子事件
      if (this.eventDetail.eventSegments) {
        this.subeventSwitch = this.eventDetail.eventSegments.length > 0 ? 1 : 0
        this.subeventList = JSON.parse(
          JSON.stringify(this.eventDetail.eventSegments)
        )
      }
      // 存一下所有事件的时间
      this.AllEventTime.EventStarttime = this.picthOnEvent.startTime
      this.AllEventTime.SubeventTime = this.SubeventTotalTime()
      this.AllEventTime.EventTime = this.eventDetail.duration
      this.AllEventTime.VideoTime =
        this.eventDetail.duration - this.AllEventTime.SubeventTime
      this.setSubeventDateLimit()
    },
    // 设置子事件选择范围并且转化显示时间
    setSubeventDateLimit () {
      if (this.eventDetail.startTime && this.eventDetail.endTime) {
        // 子事件选择范围
        this.subeventDateLimit =
          `${Outil.changeNewTime(this.eventDetail.startTime)
          } - ${
          Outil.changeNewTime(this.eventDetail.endTime) == '00:00:00'
            ? '23:59:59'
            : Outil.changeNewTime(this.eventDetail.endTime)}`
        // 存一下日期
        this.eventDetail.newdate = Outil.changeNewDate(
          this.eventDetail.startTime
        )
        // 初始时间的变化
        const EventTimeChange =
          this.eventDetail.startTime - this.AllEventTime.EventStarttime

        // 修改的上一次时间存一下
        this.AllEventTime.EventStarttime = this.eventDetail.startTime
        let SerialNumber = 0
        // 转换显示时间
        this.subeventList.forEach((item, index) => {
          if (item.segmentId == 1) {
            SerialNumber++
            item.SerialNumber = SerialNumber
          }
          if (EventTimeChange) {
            item.timingIn = item.timingIn + EventTimeChange
            item.timingOut = item.timingOut + EventTimeChange
          }
          item.accumulatedProgramTiming = item.timingOut - item.timingIn
          item.ShowTimingIn = item.timingIn
            ? Outil.changeNewTime(item.timingIn)
            : item.timingIn
          item.ShowTimingOut = item.timingOut
            ? Outil.changeNewTime(item.timingOut)
            : item.timingOut
        })
      }
    },
    // 通过子事件变化改变主事件时间
    ChangeTotalEvent () {
      // 计算时间变化
      this.AllEventTime.SubeventTime = this.SubeventTotalTime()
      this.AllEventTime.EventTime = this.AllEventTime.VideoTime + this.AllEventTime.SubeventTime
      // 子事件时间变化修改结束时间
      this.eventDetail.endTime = this.eventDetail.startTime + this.AllEventTime.EventTime
    },
    // 计算子事件的总时间
    SubeventTotalTime () {
      let SubeventTime = 0
      this.subeventList.forEach((item, index) => {
        if (item.segmentId == 2 || item.segmentId == 4) {
          if (item.timingIn && item.timingOut) {
            SubeventTime += item.timingOut - item.timingIn
          }
        }
      })
      this.AllEventTime.SubeventTime = SubeventTime
      return SubeventTime
    },
    // 计算分秒小时
    calculateInterval (time) {
      if (typeof time == 'number') {
        let hour = Math.floor(time / (60 * 60 * 1000))
        let minute = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000))
        let second = Math.floor((time % (60 * 1000)) / 1000)
        hour = hour ? `${hour}h` : ''
        minute = minute ? `${minute}m` : ''
        second = second ? `${second}s` : ''
        return hour + minute + second
      } else {
        return ''
      }
    },
    // 展示时间
    displayTime (startTime, endTime, type) {
      const startDate = Outil.getDateTime(new Date(startTime))
      const endDate = Outil.getDateTime(new Date(endTime))
      const startDay =
        `${startDate.year}-${startDate.month}-${startDate.day}`
      const endDay = `${endDate.year}-${endDate.month}-${endDate.day}`
      // type有值不返回日期
      if (type) {
        return `${startDate.hour}:${startDate.min}:${startDate.s} - ${endDate.hour
          }:${endDate.min}:${endDate.s}`
      } else if (startDay == endDay) {
        return `${startDay} ${startDate.hour}:${startDate.min}:${startDate.s
            } - ${endDate.hour}:${endDate.min}:${endDate.s}`
      } else {
        return `${startDay} ${startDate.hour}:${startDate.min} - ${endDay} ${endDate.hour
            }:${endDate.min}`
      }
    },
    // SourceType类型改变
    SourceTypeChange () {
      this.eventDetail.fileId = ''
      this.eventDetail.tpeerid = ''
      this.eventDetail.tname = ''
    }
  }
}
</script>

<style scoped lang="less">
.PopupBox {
  // position: fixed;
  // top: 0;
  // left: 0;
  .createBooking {
    position: absolute;
    max-height: 400px;
    background-color: #252525;
    border-radius: 4px;
    z-index: 2000;
    padding: 0.16rem;
    padding-right: 0.2rem;
    color: #999;
    font-size: 0.16rem;
    box-sizing: border-box;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.78);
    .EventWrapTitle {
      margin-bottom: 15px;
      .closeCreateBox {
        position: absolute;
        right: 20px;
        top: 15px;
      }
      .EventTopTitle {
        width: 362px;
        display: flex;
        p {
          margin: 0;
        }
        .event_color {
          width: 20px;
          height: 20px;
          margin-right: 10px;
          border: none;
        }
        .Event_title {
          width: 332px;
          height: 20px;
          text-align: left;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .CompileTitle {
        display: flex;
      }
      .separator {
        padding: 0 10px;
      }
      li.active {
        color: #33ab4f;
      }
    }
    .EventDetail {
      width: 362px;
      max-height: 283px;
      overflow-y: auto;
      font-size: 12px;
      margin-bottom: 10px;
      .detail_item {
        height: 32px;
        line-height: 32px;
        border-bottom: 1px solid #444444;
        padding: 0 10px;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .detailLeft {
          font-size: 12px;
          color: #666;
          margin: 0;
          text-align: left;
        }
        .detailRight {
          width: 240px;
          height: 100%;
          font-size: 12px;
          color: #dfdfdf;
          margin: 0;
          text-align: right;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        /deep/.el-input__inner {
          border: none;
          color: #dfdfdf;
          font-size: 12px;
          width: 165px;
        }
      }
      .eventsDetail {
        .detailbottom {
          border-bottom: transparent;
        }
        .detail_item {
          i {
            font-size: 15px;
          }
          .el-icon-arrow-up:before {
            content: '\E605';
          }
        }

        .eventsListWrap {
          padding: 0 10px;
          .eventsBox {
            height: 25px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #dfdfdf;
            div {
              line-height: 14px;
            }
            .title {
              width: 130px;
              text-align: left;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .time {
              width: 110px;
            }
            .duration {
              width: 50px;
              text-align: right;
            }
          }
        }
      }
      .storySlug {
        display: block;
        height: 80px;
        .detailRight {
          width: 100%;
          line-height: 14px;
          text-align: left;
          overflow: hidden;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box; /** 将对象作为伸缩盒子模型显示 **/
          -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
          -webkit-line-clamp: 3; /** 显示的行数 **/
        }
      }
    }
    .EventDetail::-webkit-scrollbar-thumb {
      background: #444444;
    }
    .EventUpdateandCreate {
      .note {
        width: 362px;
        .color_box {
          height: 100%;
          padding-right: 22px;
          position: relative;
        }
        .color_opt {
          width: 255px;
          height: 40px;
          background: #333;
          color: #999;
          border-radius: 4px;
          position: absolute;
          right: -11px;
          top: 31px;
          padding: 10px 0;
          padding-left: 6px;
          font-size: 12px;
          line-height: 20px;
          z-index: 10000;
          display: flex;
          ul {
            display: flex;
            li {
              width: 20px;
              height: 20px;
              cursor: pointer;
              margin-left: 10px;
            }
          }
        }
        .color {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          margin-top: 4px;
          box-sizing: content-box;
        }
        .el-icon-caret-bottom {
          font-size: 20px;
          position: absolute;
          top: 16%;
          right: 0px;
          transform: translateY(-50%);
          transform: rotate(0deg);
          transition: 0.3s;
        }
        .el-icon-caret-bottom.top {
          transform: rotate(-180deg);
        }

        textarea {
          width: 362px;
          border: none;
          outline: none;
          background: #444;
          border-radius: 4px;
          height: 60px;
          color: #999;
          font-size: 12px;
          line-height: 15.6px;
          padding: 2px 2px 2px 10px;
          box-sizing: border-box;
        }
        .c_item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .HouseIDKey{
            color: #999;
            font-size: 14px;
          }
          .HouseIDVaule{
            color: #999;
            font-size: 14px;
            margin-left: 6px;
            input {
              width: 285px;
            }
          }
          input {
            width: 362px;
            height: 30px;
            background-color: #444;
            color: #dbdbdb;
            border: none;
            outline: none;
            border-radius: 4px;
            text-indent: 10px;
            font-size: 12px;
            box-sizing: border-box;
            text-align: left;
          }
        }
        .DuplicateHint{
          font-size: 12px;
          line-height: 14px;
          color:#FD5454;
          text-align: left;
          padding-left: 10px;
        }
        .timeSelete {
          .time_opt {
            width: 170px;
            height: 30px;
            line-height: 26px;
            color: #000;
            background: rgba(228, 228, 228, 1);
            border: none;
            border-radius: 4px;
            /deep/.el-date-editor.el-input {
              width: 100%;
            }
            /deep/input.el-input__inner {
              width: 100%;
              height: 30px;
              background: #444;
              padding-left: 10px;
              border: none;
              color: #dfdfdf;
              font-size: 12px;
              padding-right: 0;
            }
            /deep/.el-input__prefix,
            .el-input__suffix-inner {
              display: none;
            }
          }
          .to {
            color: #999;
            margin: 0 7px;
            line-height: 30px;
            font-size: 12px;
          }
        }
        ::v-deep.RecordSelete {
          height: 20px;
          margin: 10px 0;
          .is-checked {
            .el-checkbox__inner {
              background: #33ab4f;
            }
            .el-checkbox__inner::after {
              border-color: #fff;
            }
          }

          .el-checkbox__label {
            border-color: #dbdbdb;
          }
        }
      }
      .EventsWrap {
        width: 671px;
        height: 277px;
        ::v-deep.ReferenceMedia {
          margin-bottom: 10px;
          display: flex;
          .MediaType {
            width: 110px;
          }
          .MediaSelect {
            width: 208px;
          }
          .el-input--suffix {
            background: #444444;
            .el-input__inner {
              height: 30px;
              font-size: 12px;
              color: #dbdbdb;
              padding-left: 10px;
            }
          }
          .el-select-dropdown__item {
            font-size: 12px;
            height: 30px;
            padding-left: 10px;
          }
          .el-select__caret {
            color: #999999;
          }
          .el-scrollbar__wrap {
            text-align: left;
            max-width: 240px;
            .el-scrollbar__view {
              width: 100%;
            }
          }
        }
        .EventsTitle {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          border-bottom: 2px solid #444444;
          height: 30px;
          font-size: 14px;
          color: #8c8a88;
          .MediaIndex{
            width: 10px;
          }
          .Title-item {
            width: 100px;
            margin-right: 8px;
            text-align: left;
          }
          .Duration {
            margin-right: 0;
          }
        }
        ::v-deep.EventsListWrap {
          height: 217px;
          overflow-y: auto;
          .EventsList {
            height: 40px;
            padding: 5px 0;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border-bottom: 1px solid #444444;
            .MediaIndex{
              width: 10px;
              font-size: 12px;
            }
            .Title-item {
              width: 100px;
              margin-right: 8px;
              text-align: left;
              .noSelete {
                font-size: 14px;
                color: #dbdbdb;
              }

              .el-input--suffix {
                background: #444444;
                .el-input__inner {
                  height: 30px;
                  font-size: 12px;
                  color: #dbdbdb;
                  padding-left: 10px;
                  padding-right: 0;
                }
              }
              .el-select-dropdown__item {
                font-size: 12px;
                height: 30px;
                padding-left: 10px;
              }
              .el-select__caret {
                color: #999999;
              }
              .fileSelete {
                .el-popper {
                  max-width: 200px;
                }
                .el-select-dropdown__wrap {
                  max-height: 200px;
                }
              }
            }
            .timePicker {
              .el-input--suffix {
                width: 100px;
                .el-input__inner {
                  width: 100px;
                  border: 1px solid #353535;
                  background: #444444;
                }
                .el-input__prefix,
                .el-input__suffix {
                  display: none;
                }
              }
            }
            .Duration-item {
              margin-right: 0;
              .Duration {
                font-size: 12px;
                color: #dfdfdf;
              }
            }
          }
          .addSubevent {
            text-align: right;
            font-size: 12px;
            color: #cccccc;
            padding-right: 5px;
          }
        }
      }
      .device {
        width: 362px;
        height: 210px;
        color: rgb(102, 102, 102);
        margin: 0 9px;
        .d_item {
          width: 100%;
          height: 32px;
          line-height: 32px;
          border-bottom: 1px solid rgba(153, 153, 153, 1);
          font-size: 12px;
          padding: 0 20px 0 10px;
          display: flex;
          justify-content: space-between;
          .val {
            color: #999;
            width: 56%;
            text-align: right;
            position: relative;
          }
          .ValSelet {
            padding-right: 10px;
            span {
              height: 31px;
              overflow: hidden;
            }
          }
          .ValSelet::before {
            content: '';
            position: absolute;
            top: 60%;
            left: 94%;
            border: 6px solid;
            transform: translateY(-50%);
            border-color: transparent;
            border-top-color: #999;
            transition: 0.3s;
          }
          .ValSelet.up:before {
            top: 23%;
            transform: rotate(-180deg);
          }
          .input {
            float: right;
            height: 25px;
            width: 135px;
            margin-top: 3px;
            margin-right: -20px;
            border: none;
            padding-left: 10px;
            padding-right: 20px;
            box-sizing: border-box;
            color: #999;
            background-color: transparent;
            text-align: right;
            outline: none;
          }
          .scte_ipt {
            color: #000;
          }
          .delay,
          .bitrate {
            text-align: left;
            background-color: #fff;
          }
          /deep/ .createbox_r_list {
            position: absolute;
            right: 0;
            top: 32px;
            background: #ababab;
            width: 2.2rem;
            height: 170px;
            text-align: left;
            .infinite-list {
              height: 170px;
            }
            li {
              padding-left: 10px;
              height: 32px;
              line-height: 32px;
              box-sizing: border-box;
              font-size: 12px;
              color: #666;
            }
            li:hover {
              background: rgba(0, 208, 105, 0.2);
            }
            .el-scrollbar__thumb {
              background: #fff;
            }
          }
        }
        .d_item.source {
          input {
            float: right;
            border: none;
            height: 25px;
            width: 100px;
            padding-left: 10px;
            padding-right: 25px;
            margin-right: -20px;
            margin-top: 3px;
            box-sizing: content-box;
            color: #000;
          }
        }
      }
    }
    ::v-deep #EventUpdateandCreate {
      pointer-events: none;
      input,
      textarea,
      span {
        background: #252525;
        border: 1px solid #353535;
        color: #666666;
      }
    }
    .create_footer {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      .DetailButton {
        width: 147px;
        display: flex;
        justify-content: space-between;
        margin-right: 50px;
      }
      button {
        width: 75px;
        height: 30px;
        background: #999;
        color: #fff;
        border: none;
        border-radius: 4px;
        font-size: 12px;
      }
      .ComplieButton {
        width: 155px;
        display: flex;
        justify-content: flex-end;
      }
      .save,
      .edit {
        background-color: #0c6;
        margin-left: 16px;
      }
      .delete {
        width: 56px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid rgba(153, 153, 153, 1);
        background: transparent;
      }
      .copy {
        color: #39aa50;
        border: 1px solid #39aa50;
        background: transparent;
      }
      .end_live {
        background: #f00;
        color: #fff;
      }
    }
  }
  .createBooking::before {
    content: '';
    border: 12px solid transparent;
    border-top-color: #252525;
    border-right-color: #252525;
    position: absolute;
    left: 60px;
    top: -10px;
    box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.38);
    transform: rotate(-45deg);
  }
  .createBookingRight {
    transform: translateX(-100%);
    // margin-left: -100%;
  }
  .createBookingBottom {
    transform: translateY(-100%);
  }
  .createBookingRightBottom {
    transform: translate(-100%, -100%);
  }
  .createBookingRight::before {
    left: 100%;
    transform: rotate(-45deg);
    margin-left: -100px;
  }
  .createBookingBottom::before {
    top: 100%;
    transform: rotate(135deg);
    margin-top: -15px;
  }
  // .createBookingRightBottom::before {
  //   left: 100%;
  //   top: 100%;
  //   transform: rotate(135deg) translateX(-20px);
  // }

  .green {
    border: 1px solid #0a9a5a;
    background: #0fbe71;
  }
  .skyblue {
    background-color: #46c9e1;
    border: 1px solid #0ca595;
  }
  .blue {
    background-color: rgb(14,107,209);
    border: 1px solid #126ed3;
  }
  .orange {
    background-color: #ffc573;
    border: 1px solid #d8a966;
  }
  .pink {
    background-color: #ff6a92;
    border: 1px solid #ee3656;
  }
  .yellow {
    background-color: #ffc000;
    border: 1px solid #ffc000;
  }
  .purple {
    background-color: #9248c7;
    border: 1px solid #9248c7;
  }
}
// /deep/ .create_booking.triangle:before {
//   border-top-color: #dcdcdc;
//   border-right-color: #dcdcdc;
//   border-bottom-color: transparent;
//   left: 0.6rem;
//   top: -0.095rem;
//   border-width: 12px;
//   box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.38);
//   transform: rotate(-45deg);
// }
// /deep/ .create_booking.right.triangle:before {
//   left: 3.4rem;
// }
// /deep/ .create_booking.bottom.triangle:before {
//   top: 3.05rem;
//   transform: rotate(135deg);
// }
// /deep/ .create_booking.bottom.device.triangle:before {
//   top: 2.46rem;
// }
</style>
